import { render, staticRenderFns } from "./Carousel.Item.vue?vue&type=template&id=4f082179&scoped=true&"
import script from "./Carousel.Item.vue?vue&type=script&lang=js&"
export * from "./Carousel.Item.vue?vue&type=script&lang=js&"
import style0 from "./Carousel.Item.vue?vue&type=style&index=0&id=4f082179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f082179",
  null
  
)

export default component.exports